import { render, staticRenderFns } from "./OrganizeArch.vue?vue&type=template&id=29e485fc&scoped=true&"
import script from "./OrganizeArch.vue?vue&type=script&lang=js&"
export * from "./OrganizeArch.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeArch.vue?vue&type=style&index=0&id=29e485fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e485fc",
  null
  
)

export default component.exports